import { useToast } from "../../../shadcnComponents/ui/use-toast";
import { useEffect, useMemo, useState } from "react";
import { generateRandomToken, isDevice } from "../../../Helpers/helper";
import {
  ExtensionDialog,
  ExtensionPopupContent,
  PCPageBody,
  SuccessAlert,
} from "./PricingCalculatorComponents/PriceCalMolecules/PriceCalMolecules";
import { useNavigate } from "react-router-dom";
import { ExactPricingStep } from "./PricingCalculatorComponents/PricingCalOrganisms/ExactPricingStep";
import mixpanel from "mixpanel-browser";
import { GradientDivider } from "../LocationChapters/Components/atoms";
import { Footer } from "../LocationChapters/Components/organisms";

export const AutoMode = () => {
  const { toast } = useToast();
  const navigate = useNavigate();

  const params = useMemo(() => new URLSearchParams(location.search), []);

  const [isMobile, setIsMobile] = useState(false);
  const [visitorToken, setVisitorToken] = useState("");
  const [openExtPopup, setOpenExtPopup] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);

  const handleStartExtensionFlow = () => {
    mixpanel.track(
      "Price Calculator Auto Page : install Extension Button Clicked"
    );
    if (isMobile) {
      toast({
        title: "Please switch to a desktop to sync",
        variant: "destructive",
      });
    } else {
      const token = generateRandomToken();
      localStorage.setItem("ext_at", token); // extension auth token
      setVisitorToken(token);
      setOpenExtPopup(true);
    }
  };

  const handleClickViewPrice = () => {
    mixpanel.track("Price Calculator Auto Page: Reveal Now Button Clicked");
    const username = params.get("username");
    if (username) {
      navigate(`/linkedin-pricing-calculator/u/${username}`);
    }
    setSuccessPopup(false);
  };

  useEffect(() => {
    if (window.innerWidth < 768 || isDevice()?.mobile) {
      setIsMobile(true);
    }
  }, []);

  useEffect(() => {
    if (params?.get("token")) {
      const savedToken = localStorage.getItem("ext_at");
      const receivedToken = params?.get("token");
      if (savedToken === receivedToken && params?.get("username")) {
        setSuccessPopup(true);
        localStorage?.removeItem("ext_at");
      }
    }
  }, [params]);

  return (
    <>
      {openExtPopup && (
        <ExtensionDialog
          open={openExtPopup}
          onOpenChange={setOpenExtPopup}
          content={
            <ExtensionPopupContent
              checkType="GuestFlow"
              open={openExtPopup}
              extTargetUrl="https://www.linkedin.com/in/me/"
              // extTargetUrl="https://www.linkedin.com/analytics/creator/audience/?timeRange=past_90_days"
              // extTargetUrl="https://www.linkedin.com/in/me/recent-activity/all/"
              redirectUrl={`${window.location.origin}/influencer/plugin/callback`}
              targetStartPage="profile"
              otherRedirectParams={{
                token: visitorToken,
              }}
              onOpenChange={setOpenExtPopup}
              // closeCurrentWindow={true}
            />
          }
        />
      )}
      {successPopup && (
        <SuccessAlert
          open={successPopup}
          onOpenChange={setSuccessPopup}
          onClickViewPrice={handleClickViewPrice}
        />
      )}
      <PCPageBody>
        <ExactPricingStep handleStartExtensionFlow={handleStartExtensionFlow} />
      </PCPageBody>
      <div className="w-full flex items-center flex-col bg-[#171717] text-white/70">
        <div className="w-full max-w-screen-lg md:px-5">
          <GradientDivider className="h-[1px]" />
          <Footer />
        </div>
      </div>
    </>
  );
};
